import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsxs as e, Fragment as t, jsx as i } from "react/jsx-runtime";
import { withVDSManager as o } from "@vds-core/utilities";
import { Children as l, cloneElement as r } from "react";
import d from "styled-components";
import { _findTooltipSize as a } from "../utils/TooltipSizeCalc.js";
import s from "./TitleLockupEyebrow.js";
import u from "./TitleLockupSubtitle.js";
import n from "./TitleLockupTitle.js";
var p = d.div.withConfig({
    displayName: "TitleLockupWrapper",
    componentId: "VDS__sc-1shcak8-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  text-align: ", ";\n  width: 100%;\n"])), function (_ref) {
    var e = _ref.$textAlignment;
    return e;
  }),
  b = function b(o) {
    var d = o.children,
      b = o.data,
      c = o.textAlignment,
      m = o.viewport,
      y = o.id,
      f = o.surface,
      g = function g(e) {
        var t = l.map(d, function (t) {
          if ((t && t.type && t.type.displayName ? t.type.displayName : "") === e) return t;
        });
        return t && t[0] ? t[0] : null;
      },
      L = function L() {
        var e = g("TitleLockupTitle");
        return e ? {
          titleSize: e.props.size,
          titleBold: e.props.bold
        } : {};
      },
      S = function S() {
        var e = function () {
            var e = g("TitleLockupEyebrow");
            return e ? e.props.size : null;
          }(),
          t = function () {
            var e = g("TitleLockupSubtitle");
            return e ? e.props.size : null;
          }(),
          i = b && b.subtitle && b.subtitle.size ? b.subtitle.size : t || void 0,
          o = b && b.eyebrow && b.eyebrow.size ? b.eyebrow.size : e || void 0;
        return void 0 !== i && void 0 === o ? i : void 0 !== o && void 0 === i ? o : void 0 !== o && void 0 !== i ? i : void 0;
      },
      z = function z() {
        var _L = L(),
          e = _L.titleSize,
          t = b && b.title && b.title.size ? b.title.size : e || "titleLarge";
        var i = S();
        var o = {
            bodySmall: ["bodySmall"],
            bodyMedium: ["bodyMedium"],
            bodyLarge: ["bodyLarge"],
            titleSmall: ["bodySmall", "bodyMedium", "bodyLarge", "titleSmall"],
            titleMedium: ["bodySmall", "bodyMedium", "bodyLarge"],
            titleLarge: ["bodyLarge", "bodySmall", "bodyMedium", "titleSmall"],
            titleXLarge: ["titleMedium", "bodyLarge"],
            title2XLarge: ["bodyLarge", "titleMedium", "titleLarge"],
            featureXSmall: ["bodyLarge", "titleMedium", "titleLarge"],
            featureSmall: ["titleLarge", "titleMedium", "bodyLarge"],
            featureMedium: ["titleLarge", "titleMedium", "bodyLarge"]
          },
          l = {
            bodySmall: ["bodySmall"],
            bodyMedium: ["bodyMedium"],
            bodyLarge: ["bodyLarge"],
            titleSmall: ["bodySmall", "bodyMedium"],
            titleMedium: ["bodySmall", "bodyMedium", "bodyLarge"],
            titleLarge: ["bodySmall", "bodyMedium", "bodyLarge"],
            titleXLarge: ["bodyLarge", "bodySmall", "bodyMedium", "titleMedium"],
            title2XLarge: ["bodyLarge", "bodyMedium", "titleMedium"],
            featureXSmall: ["bodyLarge", "bodyMedium", "titleMedium"],
            featureSmall: ["titleLarge", "bodyLarge"],
            featureMedium: ["titleLarge", "titleXLarge", "bodyLarge"]
          },
          r = !!o[t].includes(i);
        if (!!!l[t].includes(i) && "mobile" === m) {
          i = l[t][0];
        }
        if (!r && "mobile" !== m) {
          i = o[t][0];
        }
        return i;
      },
      v = function v() {
        var _L2 = L(),
          e = _L2.titleSize,
          t = b && b.title && b.title.size ? b.title.size : e || "titleLarge",
          i = z(),
          o = ["bodySmall", "bodyMedium", "bodyLarge", "titleSmall", "titleMedium", "titleLarge", "titleXLarge", "title2XLarge", "featureXSmall", "featureSmall", "featureMedium"];
        var l;
        return "mobile" === m ? (l = o.indexOf(t) < 3 ? "4px" : o.indexOf(t) < 6 ? "8px" : o.indexOf(t) > 9 ? "bodyLarge" === i ? "12px" : "16px" : "12px", l) : (l = o.indexOf(t) < 3 ? "4px" : o.indexOf(t) < 5 ? "8px" : o.indexOf(t) > 6 ? "bodyLarge" === i ? "12px" : "16px" : "12px", l);
      },
      M = function M(e, t) {
        return e ? Array.isArray(e) ? -1 !== e.map(function (e) {
          return e && e.type && e.type.displayName ? e.type.displayName : "";
        }).indexOf(t) : "object" == typeof e ? e.type && e.type.displayName && e.type.displayName === t : void 0 : null;
      };
    return e(p, {
      $textAlignment: c,
      id: y,
      surface: f,
      children: [!b && function () {
        var _L3 = L(),
          e = _L3.titleSize,
          t = _L3.titleBold,
          i = z(),
          a = v(),
          s = e === i;
        return void 0 !== e && e ? l.map(d, function (e, o) {
          var l = e && e.type && e.type.displayName ? e.type.displayName : "";
          return "TitleLockupSubtitle" === l ? r(e, Object.assign(Object.assign({}, e.props), {
            size: i,
            viewport: m,
            surface: f || e.props.surface,
            color: s && !t ? "secondary" : e.props.color
          })) : "TitleLockupTitle" === l ? r(e, Object.assign(Object.assign({}, e.props), {
            viewport: m,
            surface: f || e.props.surface,
            isStandAlone: !M(d, "TitleLockupSubtitle")
          })) : "TitleLockupEyebrow" === l ? r(e, Object.assign(Object.assign({}, e.props), {
            size: i,
            bold: !t || e.props.bold,
            viewport: m,
            paddingBottom: a,
            surface: f || e.props.surface,
            isStandAlone: !(M(d, "TitleLockupTitle") || M(d, "TitleLockupSubtitle")),
            uniformSize: s,
            isTitleBold: t
          })) : e;
        }) : o.children;
      }(), b && function () {
        var o;
        var l = z(),
          r = v(),
          d = !(!b || !b.title || void 0 !== b.title.bold) || (null === (o = null == b ? void 0 : b.title) || void 0 === o ? void 0 : o.bold),
          p = b && b.eyebrow && b.eyebrow.bold,
          c = b && b.title && b.title.size === l;
        return e(t, {
          children: [!!(null == b ? void 0 : b.eyebrow) && i(s, Object.assign({}, b.eyebrow, {
            isStandAlone: !b.title && !b.subtitle,
            paddingBottom: r,
            size: l,
            bold: !d || p
          }, b.eyebrow.tooltip && {
            tooltip: Object.assign(Object.assign({}, b.eyebrow.tooltip), {
              size: a(b.eyebrow.tooltip.size ? b.eyebrow.tooltip.size : void 0, l, m)
            })
          }, {
            viewport: m,
            surface: b && b.eyebrow && b.eyebrow.surface || f,
            uniformSize: c,
            isTitleBold: d
          })), !!(null == b ? void 0 : b.title) && i(n, Object.assign({}, b.title, b.title.tooltip && {
            tooltip: Object.assign(Object.assign({}, b.title.tooltip), {
              size: a(b.title.tooltip.size ? b.title.tooltip.size : void 0, b.title.size, m)
            })
          }, {
            isStandAlone: !b.subtitle,
            size: b.title.size,
            viewport: m,
            surface: b && b.title && b.title.surface || f
          })), !!(null == b ? void 0 : b.subtitle) && i(u, Object.assign({}, b.subtitle, {
            size: l,
            color: c && !d ? "secondary" : b.subtitle.color
          }, b.subtitle.tooltip && {
            tooltip: Object.assign(Object.assign({}, b.subtitle.tooltip), {
              size: a(b.subtitle.tooltip.size ? b.subtitle.tooltip.size : void 0, l, m)
            })
          }, {
            viewport: m,
            surface: b && b.subtitle && b.subtitle.surface || f
          }))]
        });
      }()]
    });
  };
b.defaultProps = {
  textAlignment: "left",
  surface: "light"
};
var c = o(b);
export { c as default };